const localHostnames = new Set(["localhost", "127.0.0.1"]);
const envLocalTest = process.env.REACT_APP_LOCAL_TEST;
const isLocalTest = envLocalTest
  ? envLocalTest.toLowerCase() === "true"
  : localHostnames.has(window.location.hostname);

const FRONT_URL =
  process.env.REACT_APP_FRONT_URL ||
  (isLocalTest ? "http://localhost:3000" : "https://screenplayer.co.uk");
const BACK_URL =
  process.env.REACT_APP_BACK_URL ||
  (isLocalTest ? "http://127.0.0.1:8000" : "https://screenplayer.co.uk");
// Public address used in canonical links, share tags and the sitemap.
// Always production, even in local builds.
const SITE_URL = "https://screenplayer.co.uk";
const API_URL = `${BACK_URL}/api`;
const APP_URL = `${FRONT_URL}/app`;

export { API_URL, FRONT_URL, APP_URL, BACK_URL, SITE_URL };
